"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require(".");
var actions_1 = require("../common/actions");
var i0 = require("@angular/core");
var i1 = require("./action.factory");
var i2 = require("./condition.factory");
var ActionService = /** @class */ (function () {
    function ActionService(actionFactory, conditionFactory) {
        this.actionFactory = actionFactory;
        this.conditionFactory = conditionFactory;
        this.actions = [];
    }
    ActionService.prototype.init = function (applicationOptions) {
        var _this = this;
        if (applicationOptions.Actions) {
            this.actions = applicationOptions.Actions.map(function (a) {
                var action = _this.actionFactory.getAction(a.Name);
                if (!a.Conditions) {
                    console.log(a.Name + " action has not been configured with any conditions");
                    return action;
                }
                a.Conditions.forEach(function (c) {
                    var condition = _this.conditionFactory.getCondition(c.Name, applicationOptions, c.Options);
                    action.addCondition(condition);
                });
                console.log(a.Name + " action is loaded with " + a.Conditions.length + " condition(s)");
                return action;
            });
        }
    };
    ActionService.prototype.start = function () {
        var enableButtonAction = this.actions.find(function (a) { return a instanceof actions_1.EnableButtonAction; });
        if (enableButtonAction) {
            enableButtonAction.invoke();
        }
        var showProactiveChatAction = this.actions.find(function (a) { return a instanceof actions_1.ShowProactiveChatAction; });
        if (showProactiveChatAction) {
            var closeInvitationAction = this.actions.find(function (a) { return a instanceof actions_1.CloseInvitationAction; });
            if (closeInvitationAction) {
                showProactiveChatAction.nextAction = closeInvitationAction;
            }
            showProactiveChatAction.invoke();
        }
    };
    ActionService.prototype.cancelAll = function () {
        this.actions.forEach(function (action) { return action.cancel(); });
    };
    ActionService.prototype.cancelCloseInvitation = function () {
        var action = this.actions.find(function (a) { return a instanceof actions_1.CloseInvitationAction; });
        if (action) {
            action.cancel();
        }
    };
    ActionService.ngInjectableDef = i0.defineInjectable({ factory: function ActionService_Factory() { return new ActionService(i0.inject(i1.ActionFactory), i0.inject(i2.ConditionFactory)); }, token: ActionService, providedIn: "root" });
    return ActionService;
}());
exports.ActionService = ActionService;
